import IconCarouselRowStyles from './icon-carousel-row';

// JW:2021-07-08 - ADO:4838 - Inline helpers to prevent load order issues
var helpers = {
  addClassToAllElements: function addClassToAllElements (elements, clss, index) {
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add(`${clss}${index}`);
    }
  },

  isInEditMode: function isInEditMode () {
    return document.body.classList.contains('pagemode-edit');
  }
}

let mySwiper;
var globalIconCarouselRowCarousels = [];
selectFormat(); toggleDropdown();
function createIconCarouselRowCarousels() {
  const IconCarouselRowCarousels = document.querySelectorAll('.swiper-container.IconCarouselRow-carousel');
  [...IconCarouselRowCarousels].map((IconCarouselRowCarousel, index) => {
    globalIconCarouselRowCarousels[index] = setCarousel(IconCarouselRowCarousel, index, !0, 0)
  })
}
function addUniqueClassToSwiperNavElements(splitCarousel, index) {
  helpers.addClassToAllElements(splitCarousel.parentNode.querySelectorAll('.IconCarouselRow__swiper-pagination'), 'IconCarouselRow__swiper-pagination', index); helpers.addClassToAllElements(splitCarousel.parentNode.querySelectorAll('.IconCarouselRow__swiper-button-next'), 'IconCarouselRow__swiper-button-next', index); helpers.addClassToAllElements(splitCarousel.parentNode.querySelectorAll('.IconCarouselRow__swiper-button-prev'), 'IconCarouselRow__swiper-button-prev', index)
}
function selectFormat() {
  const breakpoint = window.matchMedia('(max-width:768px');
  const breakpointChecker = function () {
    if (breakpoint.matches === !0) {
      if (mySwiper !== undefined) {
        mySwiper.destroy(!0, !0)
      } return
    }
    else if (breakpoint.matches === !1) {
      createIconCarouselRowCarousels()
    }
  }; breakpoint.addListener(breakpointChecker); breakpointChecker()
}
function setCarousel(IconCarouselRowCarousel, index, autoHite = !1, initialSlide = 0) {
  addUniqueClassToSwiperNavElements(IconCarouselRowCarousel, index); let slidesNumber = parseInt(IconCarouselRowCarousel.getAttribute('data-slide-num')); mySwiper = new Swiper(IconCarouselRowCarousel, { on: { init: function () { IconCarouselRowCarousel.parentNode.parentNode.classList.add('icon-carousel__powers-activate') } }, initialSlide: initialSlide, autoHeight: autoHite, slidesPerView: 6, speed: 600, spaceBetween: 20, centerInsufficientSlides: !0, allowTouchMove: !1, watchOverflow: !0, pagination: { el: '.IconCarouselRow__swiper-pagination' + index, type: 'fraction' }, navigation: { nextEl: '.IconCarouselRow__swiper-button-next' + index, prevEl: '.IconCarouselRow__swiper-button-prev' + index }, breakpoints: { 400: { slidesPerView: 2 }, 1080: { slidesPerView: 4, spaceBetween: 10, allowTouchMove: !helpers.isInEditMode() } }, }); return mySwiper
}
function toggleDropdown() {
  const menus = document.querySelectorAll(".icon-carousel__holder .swiper-container");
  [...menus].map(menu => {
    menu.addEventListener('click', () => {
      if (window.matchMedia('(max-width:768px)').matches === !0) { menu.classList.toggle("opened") }
    })
  })
}
